import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendHelpMessage } from '../../services/help.service';

export const postMessage = createAsyncThunk(
  'help/sendMessage',
  async (message) => {
    return sendHelpMessage(message);
  }
);
